// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.item[data-v-a7236900]{background:transparent;display:flex}.item-img[data-v-a7236900]{width:auto;height:24px;-o-object-fit:contain;object-fit:contain;-o-object-position:left center;object-position:left center}@media (max-width:1225px){.item-img[data-v-a7236900]{width:auto;height:20px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
